/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

angular.module('taric.model.quota',['ngResource','common.model.geoarea', 'common.helper']).factory('TariffQuota', function ($resource, CONSTANTS) {
    return $resource(CONSTANTS.host + CONSTANTS.ws_context + '/tqa/quotas/', {}, {
        queryQuotas: {
            method: 'GET',
            isArray: false
        },
        getQuotaDefinitionExtendedInfo : {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/tqa/quotas/:quotaOrderNumber/:origin'

        }
    });
}).service('TaricQuotaSearchModel', function(TariffQuota, $q, CommonHelper, CONSTANTS){
    var model = this,
    selectedQuota = null,
    searchCriteria = {},
    searchQuotaResult = null;
    model.getSelectedQuota = function (){
        return selectedQuota;
    };
    model.setSelectedQuota = function (quota){
        selectedQuota = quota;
    };
    model.getSearchCriteria = function (){
        return searchCriteria;
    };
    model.searchQuotaResult = function (){
        return searchQuotaResult;
    };
    model.resetSearchCriteria = function (){
        searchCriteria = {};
        searchCriteria.simulationDate = new Date();
        searchCriteria.ascending = true;
        searchCriteria.status = null;
        searchCriteria.critical = false;
    };
    model.resetSearchResult = function (){
        searchQuotaResult = null;
    };
    model.reset = function () {
        model.resetSearchCriteria();
        model.resetSearchResult();
    };

    model.reset();
    model.searchTariffQuotas = function(page){
        var deferred = $q.defer();
        
        var options = {
            simulationdate: CommonHelper.getRestDateString(searchCriteria.simulationDate),
            country: searchCriteria.country,
            ordernumber: searchCriteria.orderNumber,
            status: searchCriteria.status,
            critical: searchCriteria.critical,
            sortorder: searchCriteria.ascending? 'A' : 'D',
            sortcolumn: searchCriteria.sortCol,
            language: searchCriteria.language
        };
    	if (page) {
    		options.offset =  CommonHelper.getOffset(page);
    		options.count = CONSTANTS.rowsPerPage;
    	}
    	
        var result = TariffQuota.queryQuotas(options, function () {
            var returnedResult = {};
            returnedResult.totalItems = result.count;
            returnedResult.tariffQuotas = result.items;
            returnedResult.currentQuotaPage= page;
            angular.forEach(returnedResult.tariffQuotas, function(quotaItem){
                if (angular.isArray(quotaItem.excludedCountryIds)){
                     quotaItem.excludedCountryIds = quotaItem.excludedCountryIds.join(" ");
                }
            });

            if (page){
                searchQuotaResult = returnedResult;
            }
            deferred.resolve(returnedResult);
        }, function(error){
            deferred.reject(error);
        });
        
        return deferred.promise;
    };
    
    model.getSelectedRow = function (){
        var inputOrigin = selectedQuota.origin.id;
        if (searchCriteria.country !== " " && searchCriteria.country){
            inputOrigin = searchCriteria.country;
        }
        var simulationDate = null;
        if (searchCriteria.simulationDate){
            simulationDate = searchCriteria.simulationDate;
        } else {
            simulationDate =  selectedQuota.startDate;
        }
        return model.getQuotaDefinitionExtendedInfo(selectedQuota.quotaOrderNumber, inputOrigin, simulationDate);
    };
    
    model.getQuotaDefinitionExtendedInfo = function (quotaOrderNumber, origin, simulationDate){
        var deferred = $q.defer();
        var quotaExtendedInfo = TariffQuota.getQuotaDefinitionExtendedInfo({quotaOrderNumber: quotaOrderNumber, origin: origin,
                                                                                simulationdate: CommonHelper.getRestDateString(simulationDate)}, function (){
            deferred.resolve(quotaExtendedInfo);
        }, function(error){
            deferred.reject(error);
        });
        
        return deferred.promise;
    };
});



// WEBPACK FOOTER //
// ./app/taric/quota/shared/taric-quota-model.js